import React, {
	//useState,
	//useEffect,
	//useMemo,
} from 'react';

// import {
// 	useSelector,
// 	useDispatch
// } from 'react-redux';


import { GenericDictSelect } from './genericDictSelect.js'

export const AnimalSizeSelect = (props) => {
	const types = {
			1: '0-200kg',
			2: '150-300kg',
			3: '200-350kg',
			4: '250-400kg',
			5: '300-450kg',
			6: '350-500kg',
			7: '400-600kg',
			8: '500+kg'
	}

	return (
		<>
			<GenericDictSelect
				id = 'Size'
				label = 'Size'
				dataDict = { types }
				cols = { props.cols }
				controlStyle = { props.controlStyle }
				handleChange = {(evt) => props.handleChange(evt)}
				value = { props.value }
				required = { props.size }
				//pattern = {'^\d+$'}	// integer
				pattern = {'^[a-zA-Z0-9-+]+$'}
				invalidMsg = 'Select Animal size!'
				selectDotDotDot = { true }
				lock = { props.lock }
				loading = { false }
			/>
		</>
	)
}